<script context="module" lang="ts"></script>

<script lang="ts">
    import Preview from "$lib/image/Preview.svelte";
    import type { File } from "$lib/wasm/file";
    import { onMount } from "svelte";
    import { animationPlayer } from "$lib/state";
    import { COMMANDS } from "$lib/commands";

    export let file: File;

    let frames = file.getFrames();

    file.onFramesChanged.onMount(() => {
        frames = file.getFrames();
        frame = Math.min(frame, frames.length - 1);
    });

    export let frame = 0;
    let playing = false;

    let timeout: any;

    function play() {
        frame = (frame + 1) % Math.max(frames.length, 1);

        if (!$animationPlayer.loop) {
            if (frame === frames.length - 1) {
                COMMANDS.commands["animation.pause"].invoke();
                return;
            }
        }

        const current = frames[frame];
        const duration = current?.duration ?? 200;
        timeout = setTimeout(() => {
            play();
        }, duration);
    }

    function pause() {
        clearTimeout(timeout);
    }

    onMount(() => {
        const unsub = animationPlayer.subscribe(state => {
            if (state.playing !== playing) {
                playing = state.playing;
                if (playing) {
                    play();
                } else {
                    pause();
                }
            }
        });

        return () => {
            unsub();
            pause();
        };
    });

</script>

<!----------------------------------------------------------------------------->


<Preview {file} {frame} />

<!----------------------------------------------------------------------------->

<style>
    .player {
        position: absolute;
        bottom: 0;
        left: 0;
        & :global(canvas) {
            width: 20ch;
            height: 20ch;
        }
        background: var(--g100);
    }

    .buttons {

    }
</style>
